<app-static-header></app-static-header>
<section>
    <div class="main_content text-center">
      <div class="img_content">
        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/bag_img.png" class="bag_img" alt="">
          <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/chocolate_img.png" class="chocolate_img" alt="">
        <div>
        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/banner/error_text.png" width="15%" alt="">
      </div>
      <div>
        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/banner/404.png" width="40%" alt="">
      </div>
      <div>
        <p class="text-center mt-3">Uh-oh! Looks like this page is playing hide and seek!</p>
        <p class="text-center mt-1 mb-0 letsgoback" routerLink="">Let’s go back.</p>
      </div>
      <div class="mb-3">
        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/banner/gotohome_img.png" routerLink="" class="home_img" width="15%" alt="">
         <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/mouse_img.png" class="mouse_img" alt="">
      </div>
      </div>
    </div> 
    </section>
  <app-footer></app-footer>
